import PropTypes from 'prop-types';
import React from 'react';
import classnames from "classnames";

import Order from '../../records/Order';
import User from '../../records/User';
import config from "../../config";

import LoggedOutLinks from '../nav/LoggedOutLinks';
import LoggedInLinks from '../nav/LoggedInLinks';
import BasketLink from '../nav/BasketLink';
import FeatureFlag from '../general/FeatureFlag';
import FavouritesLink from '../nav/FavouritesLink';
import WebchatLink from '../nav/WebchatLink';
import DimensionsStore from '../../stores/DimensionsStore';
import connectToStores from '../../helpers/connectToStores';
import { Logo } from './Logo';

function Header ({ isMobile, user, order, disableLogin, disableNav }) {

    const brandedAccountMenuNav = config.get('brandedAccountMenuNav');

    return (
        <header className="container-fluid header" role="banner">
            <nav role="navigation" className="pull-left header__container">
                <Logo />
                { brandedAccountMenuNav && brandedAccountMenuNav.filter(({ name }) => name === "account.nav.myTrees").map(({ destination, icon }) =>
                    <a href={destination} className="header__tree-icon">
                        <i className={classnames('otrl', icon)} />
                    </a>
                )}
            </nav>

            {!disableNav &&
                <nav role="navigation" className="header__nav pull-right hidden-print">
                    <ul className="no-margin list-unstyled clearfix nav-list">

                        {!disableLogin && <React.Fragment>
                            {user.isLoggedIn() ? <LoggedInLinks user={ user }/> : <LoggedOutLinks/>}
                        </React.Fragment>}

                        {isMobile && <FeatureFlag name="enableWebchat">
                            <li className="pull-right nav-list__item nav-list__item--webchat">
                                <WebchatLink />
                            </li>
                        </FeatureFlag>}

                        <FeatureFlag name="enableHeaderBasket">
                            <li className="pull-right nav-list__item nav-list__item--basket">
                                <BasketLink order={ order }/>
                            </li>
                        </FeatureFlag>

                        {user.isLoggedIn() && <FavouritesLink user={ user }/>}

                    </ul>
                </nav>
            }
        </header>
    );
}

Header.propTypes = {
    order: PropTypes.instanceOf(Order).isRequired,
    user: PropTypes.instanceOf(User).isRequired,
    isMobile: PropTypes.bool.isRequired,
    disableNav: PropTypes.bool,
    disableLogin: PropTypes.bool,
};

export default connectToStores([DimensionsStore], () => {
    return {
        isMobile: DimensionsStore.isMobileWidth(),
    };
})(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js